import Main from '../types/enums/main';
import Rail from '../classes/rail';
import { RailDisplayMode } from '../types/enums/rail';

const dummyRail = {
  kind: '',
  url: '',
  title: '',
  eventId: '',
  channel: '',
  channelName: '',
  id: '',
  duration: 0,
  season: 0,
  channelId: '',
  dummy: true,
  synopsisLong: '',
  moviePictures: {
    background: '',
    photo: '',
    poster: '',
  },
};

const Dummy = {
  getPoster: () => {
    const getRail = (name: string) => {
      return new Rail({
        section: { name, presentationType: RailDisplayMode.POSTER },
        shows: {
          data: [
            dummyRail,
            dummyRail,
            dummyRail,
            dummyRail,
            dummyRail,
            dummyRail,
            dummyRail,
            dummyRail,
            dummyRail,
            dummyRail,
          ],
        },
      });
    };
    return {
      type: Main.RAILS,
      data: [getRail('0'), getRail('1'), getRail('2')],
    };
  },
  getPhoto: () => {
    const getRail = (name: string) => {
      return new Rail({
        section: { name, presentationType: RailDisplayMode.PHOTO },
        shows: {
          data: [dummyRail, dummyRail, dummyRail, dummyRail, dummyRail],
        },
      });
    };
    return {
      type: Main.RAILS,
      data: [getRail('0'), getRail('1'), getRail('2'), getRail('3')],
    };
  },
  getSinglePhoto: () => {
    const getRail = (name: string) => {
      return new Rail({
        section: { name, presentationType: RailDisplayMode.PHOTO },
        shows: {
          data: [dummyRail, dummyRail, dummyRail, dummyRail, dummyRail],
        },
      });
    };
    return {
      type: Main.RAILS,
      data: [getRail('0')],
    };
  },
  getRecordingRails: () => {
    return {
      type: Main.RAILS,
      data: [],
    };
  },
};
export default Dummy;
